import { GRAVITY_WEBSITE_HANDOFF_STORAGE_KEY } from './gravityWebsiteHandoffConstants.js';
import { clearRememberedGravityWebsiteHandoffId } from './gravityWebsiteHandoffMemory.js';
import readGravityWebsiteHandoff from './readGravityWebsiteHandoff.js';

const clearGravityWebsiteHandoff = (handoffId = '') => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    const storage = window.sessionStorage;
    if (storage) {
      const handoff = readGravityWebsiteHandoff();
      if (!handoffId || handoff?.handoffId === handoffId) {
        storage.removeItem(GRAVITY_WEBSITE_HANDOFF_STORAGE_KEY);
      }
    }
  } catch {
    // Handoff cleanup must never block the signed-in product.
  }

  clearRememberedGravityWebsiteHandoffId(handoffId);
};

export default clearGravityWebsiteHandoff;
